import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { SettingCard } from '../setting-card';
import { UpdateWriteUpsProps } from './write-ups.types';
import { StyledWriteUpCommunityContainer, StyledWriteUpContainer } from './write-ups.styles';
import { OfficialWriteUp } from './components/official-write-up/official-write-up';
import { CommunityWriteUps } from './components/community-write-ups/community-write-ups';
import { ForumThread } from './components/forum-thread/forum-thread';
export const WriteUps = ({
  roomDetails
}: UpdateWriteUpsProps) => <>
    <StyledWriteUpContainer aria-label="Write Up Room Write-ups" data-sentry-element="StyledWriteUpContainer" data-sentry-source-file="write-ups.tsx">
      <SettingCard title="Write-up" icon={faUsers} data-sentry-element="SettingCard" data-sentry-source-file="write-ups.tsx">
        <OfficialWriteUp roomDetails={roomDetails} data-sentry-element="OfficialWriteUp" data-sentry-source-file="write-ups.tsx" />
        <ForumThread roomDetails={roomDetails} data-sentry-element="ForumThread" data-sentry-source-file="write-ups.tsx" />
      </SettingCard>
    </StyledWriteUpContainer>

    <StyledWriteUpCommunityContainer aria-label="Community write-ups table" data-sentry-element="StyledWriteUpCommunityContainer" data-sentry-source-file="write-ups.tsx">
      <SettingCard title="Community write-ups" icon={faUsers} data-sentry-element="SettingCard" data-sentry-source-file="write-ups.tsx">
        <CommunityWriteUps roomDetails={roomDetails} data-sentry-element="CommunityWriteUps" data-sentry-source-file="write-ups.tsx" />
      </SettingCard>
    </StyledWriteUpCommunityContainer>
  </>;